export default __webpack_public_path__ + "static/media/790651340950470666.0ca92a6e.png";